<mat-menu #uploadMenu>
    <button mat-menu-item (click)="onFileUploadChange()">
        <span>Vom Computer</span>
    </button>
    <button mat-menu-item (click)="onDmsFileUploadClick(false, null)">
        <span>Aus dem DMS</span>
    </button>
</mat-menu>
<!--<input type="file" id="file" (change)="onFileUploadChange($event, null)" hidden multiple accept="image/*, application/pdf" #fileUpload />-->
<mat-expansion-panel [(expanded)]="expanded">
    <mat-drawer #drawerCollumn position="end">
        <app-table-config-form [columns]="TableColumnsSorted$ | async" [selectedColumns]="selectedColumns$ | async" (selectedColumnsChange)="selectedColumnsChange($event)"></app-table-config-form>
    </mat-drawer>
    <mat-expansion-panel-header [collapsedHeight]="DaveHeaderHeight">
        <h3 style="align-self: center;">Pläne</h3>
        <span class="spacer"></span>
        <mat-form-field *ngIf="SearchBarActive">
            <div style="display: flex;">
                <input type="text" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" placeholder="Suche" [formControl]="SearchForm" matInput #input/>
                <button class="clear-search" (click)="$event.stopPropagation(); SearchForm.setValue('')" mat-icon-button *ngIf="SearchForm.value">
                    <fa-icon icon="times"></fa-icon>
                </button>
            </div>
        </mat-form-field>
        <button app-round-button *ngIf="listVisible" [matTooltip]="SearchBarActive && !SearchForm.value ? 'Ausblenden' : 'Suche'" [attr.aria-label]="SearchBarActive && !SearchForm.value ? 'Ausblenden' : 'Suche'" (click)="$event.stopPropagation(); SearchButtonClicked()">
            <fa-icon [icon]="SearchBarActive ? 'times' : 'search'"></fa-icon>
        </button>
        <button app-round-button *ngIf="listVisible" matTooltip="Filter" aria-label="Filter" (click)="$event.stopPropagation(); filter.Open()" [matBadge]="FilterAmount$ | async" [matBadgeHidden]="!(FilterAmount$ | async)">
            <fa-icon icon="filter"></fa-icon>
        </button>
        <button app-round-button *ngIf="listVisible" [matBadge]="disabledColumns$ | async" matTooltip="Tabelle anpassen" (click)="$event.stopPropagation(); drawerCollumn.toggle()">
            <fa-icon icon="cog"></fa-icon>
        </button>
        <button app-round-button (click)="$event.stopPropagation(); drawerContent?.toggle(); toggleTable(); SearchBarActive = false; SearchForm.setValue('')" [matTooltip]="'Liste der Störungen ' + (drawerContent?.opened ? 'ausblenden' : 'einblenden')" [Active]="drawerContent?.opened" [Disabled]="(plans$ | async)?.length === 0"><fa-icon icon="list"></fa-icon></button>
        <button app-round-button (click)="$event.stopPropagation(); onStackOrderButtonClick()" [Disabled]="(plans$ | async)?.length === 0"><fa-icon icon="layer-group" matTooltip="Pläne bearbeiten"></fa-icon></button>
        <button app-round-button (click)="$event.stopPropagation();" [matMenuTriggerFor]="uploadMenu"><fa-icon icon="upload" matTooltip="Plan hinzufügen"></fa-icon></button>
        <app-filter-card #filter UnlimitedHeight [Settings]="FilterSettings$ | async" [Values]="FilterValues$ | async" (ValuesChange)="FilterValues$.next($event)" (click)="$event.stopPropagation()"></app-filter-card>
    </mat-expansion-panel-header>
    <mat-card-content class="content">
        <!--        <mat-list style="width: 15rem">-->
        <!--                        <app-event-list-entry *ngFor="let event of events$ | async" [Event]="event"></app-event-list-entry>-->
        <!--        </mat-list>-->

        <mat-drawer-container *ngIf="(plans$ | async)?.length; else noContent" class="transparent">
            <mat-drawer mode="side" #drawerContent>
                <div class="left-content">
                    <table mat-table matSort cdkDropList [dataSource]="DataSource$ | async" class="event-table" cdkDropListOrientation="horizontal" (cdkDropListDropped)="drop($event)" (matSortChange)="SortTableData($event)">
                        <ng-container *ngFor="let column of TableColumns" [matColumnDef]="column.name">
                            <th mat-header-cell cdkDrag *matHeaderCellDef [mat-sort-header]="column.name" cdkDragBoundary=".mat-header-row" cdkDragPreviewClass="mat-elevation-z2">{{ column.header }}</th>
                            <td mat-cell [style.border-left-color]="rowData.color || 'transparent'" *matCellDef="let rowData">{{ rowData[column.name] }}</td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr mat-row class="clickable-list-item" *matRowDef="let row; columns: displayedColumns" (click)="onTableRowClick(row)"></tr>
                    </table>
                </div>
            </mat-drawer>
            <mat-drawer-content *ngIf="plans$ | async as plans" class="right-content">
                <!-- <div class="resizer" *ngIf="listVisible" #resizer></div> -->
                <mat-tab-group style="flex-grow: 1" (selectedTabChange)="planSelected$.next(plans[$event.index])">
                    <mat-tab #tab [label]="plan.documentName" *ngFor="let plan of plans">
                        <ng-container *ngIf="tab.isActive">
                            <button app-round-button class="tooltip-button" (click)="map.toggleMarkerTooltipsPermanent()" [Active]="map.MarkerTooltipsPermanent" [matTooltip]="map.MarkerTooltipsPermanent ? 'Namen ausblenden' : 'alle Namen anzeigen'"><fa-icon [icon]="'message'"></fa-icon></button>
                            <app-leaflet-wrapper (MapInitialized)="setEvents2(map, plan.documentId)" #map [InitialDocument]="plan"></app-leaflet-wrapper>
                        </ng-container>
                    </mat-tab>
                </mat-tab-group>
            </mat-drawer-content>
        </mat-drawer-container>
    </mat-card-content>
</mat-expansion-panel>
<!--<ng-template #singleFileUpload>-->
<!--    <input type="file" (change)="onFileUploadChange()" hidden accept="image/*, application/pdf" />-->
<!--</ng-template>-->
<ng-template #noContent>
        <p>Keine Pläne vorhanden</p>
</ng-template>
